import * as _ from 'lodash';
import * as utility from "../misc/utility";

/**
 * @typedef { import('../server/ResponseContext').ResponseContext } ResponseContext
 */

export const auditIncidents = Object.freeze({
    undefined: 0,

    detachedEvent: 100, // Detach attendance without ceremony
    detachedMission: 101, // Can be for both ceremony and "ghost" ceremony

    ceremonyReported: 200,
    ceremonyRejected: 201,
    ceremonyAccepted: 202,
    ceremonyReset: 203, // Ceremony reset because attendance removed.

    timeRequested: 300,
    timeReported: 301,
    timeRejected: 302,
    timeAccepted: 303,
    timeRecalled: 304,
    timeRemoved: 305,

    claimReported: 400,
    claimRejected: 401,
    claimAccepted: 402,
    claimReset: 403,
    claimRecalled: 404,
    
    certificationRequested: 500,
    certificationRecalled: 501,
    certificationRejected: 502,
    certificationAccepted: 503,
    certificationClaimRejected: 504,
});

export class AuditData {
    constructor(src) {
        this.Incident = src.Incident;
        this.Timestamp = utility.parseDate(src.Timestamp);
        this.Message = src.Message;
        this.UserId = src.UserId;
        this.PersonId = src.PersonId;
    }

    /**
     * @param {ResponseContext} ctx
     */
    resolve(ctx) {
        this.Person = ctx.getPerson(this.PersonId);
    }

    /**
     * @param {any} src
     * @param {ResponseContext} ctx
     */
    static create(src, ctx) {
        const result = new AuditData(src);
        result.resolve(ctx);
        return result;
    }
}